/**
 * Single source of truth for awards and recognition.
 *
 * Consumed by AchievementsAwards (detailed cards, `featured` only) and
 * AboutArea (compact chips, all of them). Update wording here only.
 *
 * icon: key mapped to a lucide component by each consumer, so this file
 *       stays plain data with no JSX.
 * short: one-line phrasing for the chip row.
 */
const awards = [
  {
    id: 1,
    year: "2025",
    title: "Startup WorldCup Winner",
    short: "Winner at Startup WorldCup 2025, Nepal",
    description:
      "Recognised among the most innovative technology startups in Asia Pacific.",
    icon: "trophy",
    featured: true,
  },
  {
    id: 2,
    title: "Startup WorldCup, Silicon Valley",
    short: "Represented the company in Silicon Valley, USA",
    description:
      "Represented the company at the Startup WorldCup global final in Silicon Valley, USA.",
    icon: "star",
    featured: false,
  },
  {
    id: 3,
    year: "2023",
    title: "GSEA Nepal Winner",
    short: "Winner at GSEA Nepal 2023",
    description:
      "National winner of the Global Student Entrepreneur Awards in Nepal.",
    icon: "medal",
    featured: true,
  },
  {
    id: 4,
    year: "2024",
    title: "NYEF Startup Award Winner",
    short: "Winner at NYEF Startup Awards",
    description:
      "Recognised by the Nepalese Young Entrepreneurs' Forum for high-growth potential.",
    icon: "award",
    featured: true,
  },
];

/** The three shown as full cards in the recognition section. */
export const featuredAwards = awards.filter((award) => award.featured);

export default awards;
